import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "content-wrapper"
};
import { ref, watch } from 'vue';
import { useDraggable } from '@vueuse/core';
import { CaretRight } from "@element-plus/icons-vue";
export default {
  __name: 'DraggableContainer',
  props: {
    data: {
      type: [Object, null],
      default: null
    },
    locked: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const containerRef = ref(null);
    const x = ref(props.data?.x ?? 0);
    const y = ref(props.data?.y ?? 0);
    const width = ref(props.data?.width ?? 0);
    const height = ref(props.data?.height ?? 0);
    const translucent = ref(props.data?.translucent ?? false);
    const {
      position
    } = useDraggable(containerRef, {
      initialValue: {
        x: props.data.x,
        y: props.data.y
      },
      onMove: () => {
        if (!isResizing && !props.locked) {
          x.value = position.value.x;
          y.value = position.value.y;
        }
      },
      onEnd: () => {
        if (!isResizing && !props.locked) {
          emitUpdate();
        }
      }
    });
    let isResizing = false;
    let startX = 0;
    let startY = 0;
    let startWidth = 0;
    let startHeight = 0;

    const handleResizeStart = e => {
      isResizing = true;
      startX = e.clientX;
      startY = e.clientY;
      startWidth = width.value;
      startHeight = height.value;
      document.addEventListener('mousemove', handleResizeMove);
      document.addEventListener('mouseup', handleResizeEnd);
    };

    const handleResizeMove = e => {
      if (!isResizing) return;
      width.value = Math.max(props.data?.minWidth ?? 50, startWidth + (e.clientX - startX));
      height.value = Math.max(props.data?.minHeight ?? 100, startHeight + (e.clientY - startY));
    };

    const handleResizeEnd = () => {
      if (isResizing) {
        isResizing = false;
        document.removeEventListener('mousemove', handleResizeMove);
        document.removeEventListener('mouseup', handleResizeEnd);

        if (width.value === props.data.width && height.value === props.data.height) {
          translucent.value = !translucent.value;
        }

        emitUpdate();
      }
    };

    const emitUpdate = () => {
      emits('update', { ...props.data,
        x: x.value,
        y: y.value,
        width: width.value,
        height: height.value,
        translucent: translucent.value
      });
    };

    watch(() => props.data, newValue => {
      x.value = newValue.x;
      y.value = newValue.y;
      width.value = newValue.width;
      height.value = newValue.height;
      translucent.value = newValue.translucent;
    }, {
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");

      return _openBlock(), _createElementBlock("div", {
        ref_key: "containerRef",
        ref: containerRef,
        class: "draggable-container",
        style: _normalizeStyle({
          position: 'absolute',
          left: `${x.value}px`,
          top: `${y.value}px`,
          width: `${width.value}px`,
          height: `${height.value}px`
        })
      }, [_withDirectives(_createVNode(_component_el_icon, {
        size: 24,
        onMousedown: handleResizeStart
      }, {
        default: _withCtx(() => [_createVNode(_unref(CaretRight))]),
        _: 1
      }, 512), [[_vShow, !props.locked]]), _createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default")])], 4);
    };
  }

};